import React from 'react';
import { Clock, Zap } from 'lucide-react';
import Logo from '../Logo';
import { NeuroMessageSet } from './NeuroMessages';

interface IntroModalProps {
  activity: {
    title: string;
    duration: number;
    points_reward: number;
  };
  messages: NeuroMessageSet;
  onClose: () => void;
  onStart: () => void;
}

export function IntroModal({ activity, messages, onClose, onStart }: IntroModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl max-w-md w-full mx-4 p-8 text-center">
        <div className="mb-6">
          <Logo size="xl" variant="icon-only" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-4 font-baloo">
          {activity.title}
        </h2>

        <p className="text-lg text-gray-700 mb-6 font-baloo">
          {messages.intro}
        </p>

        <p className="text-gray-600 mb-8">
          {messages.instruction}
        </p>

        <div className="flex items-center justify-center space-x-4 mb-6 text-sm text-gray-500">
          <div className="flex items-center space-x-1">
            <Clock className="w-4 h-4" />
            <span>{Math.floor(activity.duration / 60)}:{(activity.duration % 60).toString().padStart(2, '0')}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Zap className="w-4 h-4" />
            <span>{activity.points_reward} points</span>
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            onClick={onClose}
            className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 font-semibold transition-colors font-baloo"
          >
            Maybe Later
          </button>
          <button
            onClick={onStart}
            className="flex-1 px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-xl hover:opacity-90 font-semibold transition-opacity font-baloo"
          >
            Let's Focus!
          </button>
        </div>
      </div>
    </div>
  );
}
